import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import pixLogo from "assets/pix.svg";

const Wrap = styled.div`
  margin-top: 24px;
  opacity: ${(p) => (p.$disabled ? 0.4 : 1)};
  pointer-events: ${(p) => (p.$disabled ? "none" : "auto")};
`;

const SectionLabel = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: var(--text-dark, #1D1D1F);
  margin: 0 0 12px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Radio = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid var(--button-primary-color, #1D1D1F);
  background: #FFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

const RadioDot = styled.span`
  width: 12px;
  height: 12px;
  background: var(--button-primary-color, #1D1D1F);
  border-radius: 50%;
`;

const Pix = styled.img`
  width: 28px;
  height: 28px;
`;

const PixLabel = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; 
  color: var(--text-dark, #1D1D1F);
`;

const Badge = styled.span`
  font-size: 12px;
  color: var(--text-dark, #1D1D1F);
  background: #F5F5F7;
  border-radius: 10px;
  padding: 4px 10px;
  margin-left: auto;
`;

const Hr = styled.div`
  height: 1px;
  background: #D9D9D9;
  margin-top: 24px;
`;

export default function PixSection({ selected, onSelect, disabled }) {
  return (
    <>
      <Wrap $disabled={disabled}>
        <Row>
          <Radio
            onClick={() => onSelect(!selected)}
            type="button"
            aria-label="Pix"
          >
            {selected && <RadioDot />}
          </Radio>
          <Pix src={pixLogo} alt="Pix" />
          <PixLabel>Pix</PixLabel>
          <Badge>Aprovação em minutos</Badge>
        </Row>
      </Wrap>
      <Hr />
    </>
  );
}

PixSection.propTypes = {
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
